import AddTeacherPage from "@/pages/teachers/add-teacher";
import PrivateLayout from "@/components/layouts/private-layout";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/teachers/new")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PrivateLayout>
      <AddTeacherPage />
    </PrivateLayout>
  );
}
